/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    name: 'login',
    path: '/login',
    component: import('@/views/auth/Login.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    name: 'logout',
    path: '/logout',
    component: import('@/views/auth/Login.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/reset-pass',
    component: import('@/views/auth/ResetPass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/create-pass',
    component: import('@/views/auth/CreatePass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/confirm-reset-pass',
    component: import('@/views/auth/ConfirmResetPass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: import('@/views/Dashboard.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/country',
    name: 'Country',
    component: import('@/views/country/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/site',
    name: 'Sites',
    component: import('@/views/site/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/lab',
    name: 'Labs',
    component: import('@/views/lab/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/account',
    name: 'Accounts',
    component: import('@/views/account/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/account/:id',
    name: 'Accounts',
    component: import('@/views/account/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol',
    name: 'Protocols',
    component: import('@/views/protocol/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol_has_site',
    name: 'Protocol Sites',
    component: import('@/views/protocol_has_site/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/points',
    name: 'Points',
    component: import('@/views/point/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/shipments',
    name: 'Shipments',
    component: import('@/views/shipment/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/shipment',
    name: 'New Shipment',
    component: import('@/views/shipment/Edit.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/shipment/:id',
    name: 'Edit Shipment',
    component: import('@/views/shipment/Edit.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/sfd/:id',
    name: 'ShipmentDriver',
    component: import('@/views/shipment/Driver.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/request_account',
    name: 'Request Account',
    component: import('@/views/account/Request.vue'),
    meta: { layout: 'no-sidebar' }
  },
]
